import { usePathname, useUnstableGlobalHref } from 'expo-router';

import logger from 'utils/logger';

/** NOTE!
 * these redirects can be removed once:
 * - all links are eliminated referencing them (check braze, branch, emails, etc.)
 * - nearly 100% of users are on 7.47.0+
 */
const legacyRedirects: [RegExp, string][] = [
  // simple /foo/bar -> /baz
  [/^\/signup$/, '/signin'],
  [/^\/rewards\/details$/, '/rewards'],
  [/^\/store-locator\/address$/, '/store-locator/delivery-address'],
  [/^\/account\/payment\/add-card$/, '/payment/edit-card'],
  [/^\/account\/payment\/add-gift-card$/, '/payment/add-gift-card'],
  [/^\/account\/payment\/transfer-gift-card$/, '/payment/transfer-gift-card'],

  // menu routes
  [/^\/menu\/section-(.*)$/, '/menu/section'], // /menu/section-ID -> /menu/section/ID
  [/^\/menu\/item-(.*)$/, '/menu/item'], // /menu/item-ID -> /menu/section/ID
  [/^\/menu\/picker-(.*)$/, '/menu/picker'], // /menu/picker-ID -> /menu/section/ID OR /menu/picker-picker_4735 -> /menu/picker/picker_4735 etc.
  [/^\/menu\/combo-(.*)$/, '/menu/combo'], // /menu/combo-ID -> /menu/section/ID

  // complex /foo/bar* -> /baz* ETC
  [/^\/rewards\/offers(?:\/([^/]+))?$/, '/offers'], // /rewards/offers* -> /offers*
  [/^\/rewards\/list(?:\/([^/]+))?$/, '/rewards'], // /rewards/list* -> /rewards*
  [/^\/rewards\/offers-group(?:\/([^/]+))?$/, '/rewards/group'], // /rewards/offers-group/* -> /rewards/group/*
];

export const useMaybeGetLegacyRedirect = () => {
  const pathname = usePathname();
  const fullPath = useUnstableGlobalHref();

  return maybeGetLegacyRedirect(pathname, fullPath);
};

export const getUrlOrRedirect = (path: string) => {
  if (!path) {
    return path;
  }

  try {
    const pathNoProtocol = path.replace(/^burgerking?:\/\//i, '');
    const pathNoQuery = pathNoProtocol.split('?')[0];
    const pathWithQuery = pathNoProtocol;

    return maybeGetLegacyRedirect(pathNoQuery, pathWithQuery) ?? path;
  } catch (error) {
    logger.error({ message: 'getUrlOrRedirect error ', error, path });
  }
  return path;
};

export const maybeGetLegacyRedirect = (pathNoQuery: string, pathWithQuery: string) => {
  for (const [rgx, redirect] of legacyRedirects) {
    // check if the pathname matches the regex against pathNoQuery which should never include a hostname per spec
    const match = rgx.exec(pathNoQuery);

    if (match) {
      let redirectBuilder = match?.[1] ? `${redirect}/${match?.[1]}` : redirect;

      const queryString = pathWithQuery.split('?')?.[1]; // not sure if we have this but just in case
      if (queryString) {
        redirectBuilder += `?${queryString}`;
      }

      if (__DEV__) {
        // eslint-disable-next-line no-console
        console.log('Legacy redirect', { from: pathWithQuery, to: redirectBuilder });
      }

      return redirectBuilder;
    }
  }

  return null;
};
